import React from "react";
import {
  FormControl as MuiFormControl,
  FormControlLabel as MuiFormControlLabel,
  RadioGroup as MuiRadioGroup,
  Radio as MuiRadio,
} from "@mui/material";

function RadioBasic({
  items = [], // object array
  defaultValue = "", // any
  value = "", // any
  row = true, // bool
  onChange = (e) => {},
}) {
  const ChangeRadio = (e) => {
    onChange(e.target.value);
  };

  return (
    <MuiFormControl>
      <MuiRadioGroup row={row} value={value} onChange={ChangeRadio}>
        {items.map((item, index) => {
          return (
            <MuiFormControlLabel
              key={index}
              value={item.value}
              label={item.name}
              disabled={item.disabled}
              sx={item.labelSx}
              labelPlacement={item.namePlacement} // 'bottom' | 'end' | 'start' | 'top'
              control={
                <MuiRadio
                  checkedIcon={item.checkedIcon}
                  color={item.color}
                  disableRipple={item.disableRipple}
                  icon={item.icon}
                  id={item.id}
                  inputProps={item.inputProps}
                  inputRef={item.inputRef}
                  required={item.required}
                  size={item.size}
                  sx={item.sx}
                  disabled={item.disabled}
                  checked={item.checked}
                />
              }
            />
          );
        })}
      </MuiRadioGroup>
    </MuiFormControl>
  );
}

export default React.memo(RadioBasic);
